import { Box, Tag, TagColor, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

export const CoffreFortNumeriqueFailedTag = () => {
  return (
    <Box width="full" gap="s16">
      <Box>
        <Tag inline leftItem="circle" showCircle type={TagColor.radical}>
          {i18n.t('settings.edit_company.coffre_fort_numerique_form.status.failed')}
        </Tag>
      </Box>
      <Box>
        <Text.Normal size="200">
          {i18n.t('settings.edit_company.coffre_fort_numerique_form.missing_employee')}
        </Text.Normal>
      </Box>
    </Box>
  )
}
